export default __webpack_public_path__ + "static/media/tag-black.0a810cbf.svg";